import useKeyContactsQuery from '~/hooks/services/servicenow/queries/useKeyContactsQuery'

import Button from '~/components/Common/Button'
import Popover from '~/components/Common/Popover'

import { classNames } from '~/utils/classNames'

import { Iconly } from 'react-iconly'

import { Tile, TileHeader, TileListContent, TileListItem } from '../Tile'

const ICON_BUTTON_CLASSES = 'flex h-12 w-12 flex-none items-center justify-center rounded-full bg-th-content-secondary'
const ICON_CLASSES = 'icon h-10 w-10 rounded-full p-1.5 xs:p-2'

const ContactIcon = () => (
  <div className={ICON_BUTTON_CLASSES}>
    <Iconly name="User" className={ICON_CLASSES} />
  </div>
)

const ContactActionButton = ({ href, icon, tooltip }: { href?: string; icon: string; tooltip: string }) => (
  <div className={classNames(ICON_BUTTON_CLASSES, !href ? 'cursor-default opacity-50' : 'cursor-pointer duration-100 hover:brightness-125')}>
    {href ? (
      <Popover text={tooltip} delay={150}>
        <a href={href}>
          <Iconly name={icon} className={ICON_CLASSES} />
        </a>
      </Popover>
    ) : (
      <Iconly name={icon} className={ICON_CLASSES} />
    )}
  </div>
)

const ContactCard = ({ contact }: { contact: any }) => {
  const displayName =
    contact.first_name === 'Customer' && contact.last_name === 'Success' ? 'Customer Success Team' : `${contact.first_name} ${contact.last_name}`

  return (
    <TileListItem key={contact.id}>
      <div className="flex gap-4">
        <ContactIcon />

        <div className="flex flex-auto items-center">
          <div>
            <TileListItem.Title>{displayName}</TileListItem.Title>
            <TileListItem.Subtitle>{contact.role}</TileListItem.Subtitle>
          </div>
        </div>

        <div className="flex gap-2">
          <ContactActionButton
            icon="Calling"
            tooltip={contact.phone || 'No phone number available'}
            href={contact.phone ? `tel:${contact.phone}` : undefined}
          />
          {contact.email && <ContactActionButton icon="Message" tooltip={contact.email} href={`mailto:${contact.email}`} />}
        </div>
      </div>
    </TileListItem>
  )
}

const KeyContactsTile = () => {
  const { data: keyContacts = [], isLoading: isKeyContactsLoading } = useKeyContactsQuery()

  return (
    <Tile>
      <TileHeader loading={isKeyContactsLoading}>
        <TileHeader.Title>My Account</TileHeader.Title>
        <TileHeader.Subtitle>Your dedicated support team</TileHeader.Subtitle>
        <TileHeader.Item>
          <Popover text="Call 0800 368 1831" delay={100}>
            <Button variant="primary" onClick={() => window.open('tel: 08003681831', '_self')} className="flex gap-2">
              <span className="mr-1.5 flex h-5 w-5 items-center">
                <Iconly name="Calling" set="light" />
              </span>
              Call Support
            </Button>
          </Popover>
        </TileHeader.Item>
      </TileHeader>

      <TileListContent>
        {keyContacts.map((contact, index) => (
          <ContactCard key={index} contact={contact} />
        ))}
      </TileListContent>
    </Tile>
  )
}

export default KeyContactsTile
